module.exports = __webpack_public_path__ + "img/img5.0fd13939.png";